import React from 'react';
import {authenticatedGetRequest} from '../../../../../src/client/helpers/requests';
import {dateHelpers as Date} from '../../../helpers';

class ToDoList extends React.Component {

    state = {
        starRating: null,
    }

    componentWillMount() {
        const id = localStorage.getItem('person_id');

        this.getStars(id).then((result, i) =>
            this.setState({starRating: result}));
    }

    getStars = async (id) => {
        return authenticatedGetRequest(`/profiles/${id}/star-rating`)
          .then((result) => {
             return result.data.star_rating ? result.data.star_rating: 0;
          })
        .catch((error) => {
            return 0;
        });
      }

    render() {
        const {scrollToSection, todoList} = this.props;

        const starSectionList = todoList && todoList.map((todoItem, id) => {
            return (
                <li key={id} className="todo-item">
                    <a className="item-link" onClick={() => scrollToSection(`section-${id}`)}>
                        {
                            todoItem.todo_list_people[0] && Date.isDateLaterThanNow(todoItem.todo_list_people[0].expires_at) ?
                                <img className="link-image" src="/images/icons-new/star.svg" alt="star full" />
                                :
                                <img className="link-image" src="/images/icons-new/star-grey.svg" alt="star empty" />
                        }
                        {todoItem.item_name}
                    </a>
                </li>
                )
            }
        );

        return (
            <div className="todo-list" data-aos>
                <div className="list-head">
                    <h3 className="heading-two">My Stars</h3>
                    <span className="stars-number">{this.state.starRating}/10</span>
                </div>
                <ul className="inner-list">
                     {starSectionList}
                </ul>
            </div>
        );
    };
};

export default ToDoList;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/ToDoList.js